const LogFields = {
  HOSTNAME: "_HOSTNAME",
  MESSAGE: "MESSAGE",
  PID: "_PID",
  SYSLOG_IDENTIFIER: "SYSLOG_IDENTIFIER"
};

module.exports = LogFields;



// WEBPACK FOOTER //
// ./src/js/constants/LogFields.js